import { Platform } from 'react-native'
import PackageJson from '../../package.json'

const clientIdentifier = `ma-${Platform.OS}-${PackageJson.version}`.toLowerCase()

export type ServiceHeaders = Record<string, string>

export const serviceHeaders: ServiceHeaders = {
  'X-Client-Identifier': clientIdentifier,
}
